export const BaseURL_twitter = `https://api.stockwiseanalytics.com/image/imagetotweet`;
